import { FETCH_PARTNER_ORDERS_RESPONSE } from './action'

const initialState = {
    partnerOrders: {
        data : [],
        noOfPages : 0
    },
};
const internationalReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PARTNER_ORDERS_RESPONSE:
            return state = {
                ...state,
                partnerOrders: {
                    data : action.data.data,
                    noOfPages : action.data.noOfPages
                } 
            }
        default: // need this for default case
            return state 
    }
}
export default internationalReducer;